/*
 * @Author: kim
 * @Date: 2021-07-21 15:57:36
 * @Description: axios 默认配置
 */
import { sessionStorage } from '../utils/storage'
import { USER_INFO } from '../utils/enum'

// 默认配置
export const defaultConfig = {
  method: 'get',
  headers: {
    // withCredentials: true,
    'X-CSRF-TOKEN': sessionStorage.isExistItem(USER_INFO) ? sessionStorage.getItem(USER_INFO).data : ''
  }
}


// WEBPACK FOOTER //
// ./pc/yiqijian-video/config/axios.js